import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import UserAvatar from '../mini/UserAvatar'
import styled from 'styled-components'
import { H1, H5, P1, P2, Caption1 } from '../styled/typography/typography'
import Modal from '../mini/Modal'
import { useDispatch } from 'react-redux'
import { hideModal } from '../../actions/_modal'
import useLexicon from '../../hooks/useLexicon'
import { useTheme } from 'styled-components'

const H1PeerList = styled(H1)`
  text-align: center;
`

const P1PeerList = styled(P1)`
  text-align: center;
  margin-top: 4px;
`

const QuestPeersModal = ({
  activePeersCount,
  activities,
  activityIndex,
  questActivities
}) => {
  const dispatch = useDispatch()
  const lexicon = useLexicon()
  const theme = useTheme()
  const close = () => {
    dispatch(hideModal())
  }

  useEffect(() => {
    const currentActivityEl = document.querySelector(
      `#peers-activity-${activityIndex}`
    )

    if (currentActivityEl) {
      currentActivityEl.scrollIntoView(true, {
        behavior: 'smooth'
      })
    }
  }, [])

  const getActivities = () => {
    const filteredActivities = activities.filter(
      activity => activity.users.length > 0
    )

    return filteredActivities.map((activity, index) => {
      const questActivityIndex = questActivities.findIndex(
        qa => qa.id === activity.activity_id
      )
      const isCurrentActivity = questActivityIndex === activityIndex

      return (
        <li
          key={`peers-activity-${index}`}
          id={`peers-activity-${index}`}
          className="peers-activity"
        >
          <P2 className={`status-bar ${isCurrentActivity ? 'active' : ''}`}>
            <span/>
            {isCurrentActivity ? 'Also on ' : ''}{lexicon.activity}{' '}
            {questActivityIndex + 1}:{' '}
            {questActivityIndex > -1
              ? questActivities[questActivityIndex].name
              : ''}
          </P2>
          <ol>
            {activity.users.length > 0 ? (
              getPeers(activity)
            ) : (
              <Caption1 className="no-peers">
                No peers on this {lexicon.activity.toLowerCase()}.
              </Caption1>
            )}
          </ol>
        </li>
      )
    })
  }

  const getPeers = activity =>
    activity.users.map((peer, index) => (
      <li key={`user-${index}`} className="user">
        <UserAvatar
          size={38}
          borderRadius={7}
          key={index}
          photoUrl={peer.photo_url}
        />
        <H5 className="name">{peer.name}</H5>
      </li>
    ))

  return (
    <Modal
      width={574}
      maxPercentHeight={80}
      top={50}
      closeCallback={close}
    >
      <div className={`peer-list-modal peer-list-modal-${theme?.style}`}>
        <div className="header">
          <H1PeerList>My Peers</H1PeerList>
          <P1PeerList>
            {activePeersCount > 1 ? (
              <span>{activePeersCount} others are on this {lexicon.quest.toLowerCase()} with you.</span>
            ) : (
              <span>Someone is on this {lexicon.quest.toLowerCase()} with you.</span>
            )}
          </P1PeerList>
          <div className='close' onClick={close}/>
        </div>
        <ul className="peers-activities">{getActivities()}</ul>
      </div>
    </Modal>
  )
}

QuestPeersModal.propTypes = {
  questActivities: PropTypes.array,
  activePeersCount: PropTypes.number,
  activityIndex: PropTypes.number,
  activities: PropTypes.array
}

export default QuestPeersModal
